// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 11H7V9H9V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 13V15H15V13H17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 9V11H15V9H17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 21H0V3H24V21ZM7 7C5.89543 7 5 7.89543 5 9V17H7V13H9V17H11V9C11 7.89543 10.1046 7 9 7H7ZM13 7V17H17C18.1046 17 19 16.1046 19 15V9C19 7.89543 18.1046 7 17 7H13Z"}}]};

const TagStateFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tag-state-filled',
    ref,
    icon: element,
  },
));

TagStateFilledIcon.displayName = 'TagStateFilledIcon';

export default TagStateFilledIcon;
